<div class="container-fluid pt-0">
  <div class="row wrap align-items-start gap-3 gap-lg-0">
    <div class="col-12 col-lg-4">
      <aside>
        <span>Filtra la ricerca</span>
        <div class="mt-3 fixed-height">
          <mat-accordion *ngFor="let l of types">
            <mat-expansion-panel #expansionPanel>
              <mat-expansion-panel-header (click)="checkHeader(l.type)">
                <mat-checkbox class="py-1" #checkboxType (change)="onCheck($event, l.type)" (click)="$event.stopPropagation()">{{ l.type }}</mat-checkbox>
              </mat-expansion-panel-header>
              <div class="d-flex justify-content-end text-end gap-2" *ngIf="l.type == 'Servizi educativi per l\'infanzia'">
                <div class="icon-container red-icon">
                    <span class="marker-icon"></span>
                    Privato
                </div>
                |
                <div class="icon-container blue-icon">
                    <span class="marker-icon"></span>
                    Pubblico
                </div>
              </div>
              <div class="fixed-width">
                <div class="border-bottom border-light py-1" *ngFor="let st of l.subtypes">
                  <mat-checkbox class="ps-3 py-1" #checkbox (change)="onCheck($event, l.type, st.subtype)"
                    [checked]="isChecked(l.type, st.subtype)">{{st.subtype}}</mat-checkbox>
                  <div class="d-block" *ngIf="isChecked(l.type, st.subtype) && st.classes && st.classes.length">
                    <mat-checkbox class="ps-4 py-1 d-block" *ngFor="let cls of st.classes"
                      (change)="onClassCheck($event, l.type, st.subtype, cls)"
                      [checked]="isClassChecked(l.type, st.subtype, cls)">{{cls}}</mat-checkbox>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
        <br />
        <div class="">
          <form [formGroup]="searchForm">
            <mat-form-field class="w-100">
              <input (keyup.enter)="search()" matInput placeholder="Denominazione" formControlName="denominazione">
            </mat-form-field>
            <mat-form-field class="w-100">
              <mat-select (keyup.enter)="search()" placeholder="Provincia" formControlName="provincia">
                <mat-option value="">Nessuna selezione</mat-option>
                <mat-option value="FR">Frosinone</mat-option>
                <mat-option value="LT">Latina</mat-option>
                <mat-option value="RI">Rieti</mat-option>
                <mat-option value="RM">Roma</mat-option>
                <mat-option value="VT">Viterbo</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="w-100">
              <mat-label>Comune o Località</mat-label>
              <input matInput formControlName="comune" [matAutocomplete]="auto">
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let option of comuniDatasource | async" [value]="option">
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field class="w-100" *ngIf="searchForm.controls['comune'].value?.toLowerCase() == 'roma'">
                <mat-select (keyup.enter)="search()" placeholder="Municipio" formControlName="municipio">
                  <mat-option value="">Nessuna selezione</mat-option>
                  <mat-option *ngFor="let m of municipi" [value]="m">{{m}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="w-100">
              <input (keyup.enter)="search()" matInput placeholder="Indirizzo o CAP" formControlName="indirizzo">
            </mat-form-field>
            <mat-form-field class="w-100">
              <input (keyup.enter)="search()" matInput placeholder="Distretto socio-sanitario"
                formControlName="distretto">
            </mat-form-field>
          </form>
          <div class="d-flex align-items-center justify-content-between gap-1 pt-3 w-100">
            <div class="d-none d-lg-flex align-items-center">
              <h6 *ngIf="results.data.length > 0">Di seguito {{ results.data.length }} risultati</h6>
              <mat-icon class="bounce" *ngIf="results.data.length > 0">keyboard_return</mat-icon>
            </div>
            <div>
              <button mat-raised-button color="accent" aria-label="reset" class="me-1" (click)="clear()">Azzera</button>
              <button mat-raised-button color="primary" aria-label="cerca" (click)="search()">Cerca</button>
            </div>
          </div>
        </div>
      </aside>
    </div>
    <div class="col-12 col-lg-8">
      <main>
        <mat-card class="mat-elevation-z8 p-12">
          <div fxLayout.xs="column-reverse" fxLayout.sm="column-reverse" fxLayout="row wrap" class="gap-1">
            <div fxFlex class="ps-0" #map>
              <div class="map-container">
                <div id="map"></div>
              </div>
            </div>
          </div>
        </mat-card>
      </main>
    </div>
  </div>
</div>

<div class="my-5" *ngIf="results.data.length > 0">
  <p></p>
</div>

<div class="container-fluid px-3 my-5" *ngIf="results.data.length > 0">
  <h6>Risultati di ricerca</h6>
  <div class="row">
    <div class="col-12">
      <mat-table #table [dataSource]="results" class="table-condensed">
        <ng-container matColumnDef="name">
          <mat-header-cell fxFlex *matHeaderCellDef>Denominazione</mat-header-cell>
          <mat-cell fxFlex *matCellDef="let row">{{row.marker_NAME}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="indirizzo">
          <mat-header-cell fxFlex="20" *matHeaderCellDef>Indirizzo</mat-header-cell>
          <mat-cell fxFlex="20" *matCellDef="let row">{{row.marker_METADATA?.Indirizzo}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="cap">
          <mat-header-cell fxFlex="5"  *matHeaderCellDef>CAP</mat-header-cell>
          <mat-cell fxFlex="5" *matCellDef="let row">{{row.marker_METADATA?.CAP}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="comune">
          <mat-header-cell fxFlex="15"  *matHeaderCellDef>Comune</mat-header-cell>
          <mat-cell fxFlex="15" *matCellDef="let row">{{row.marker_METADATA?.Comune || row.marker_METADATA?.['Località']
            }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="classe">
          <mat-header-cell fxFlex="20" *matHeaderCellDef>Classe di Utenza</mat-header-cell>
          <mat-cell fxFlex="20" *matCellDef="let row">{{row.marker_SUBTYPES}} - {{row.marker_METADATA?.['Classe di Utenza']}}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row class="hover" *cdkRowDef="let row; columns: displayedColumns;" (click)="showDetails(row)"></mat-row>
      </mat-table>
    </div>
  </div>
</div>
<div class="my-4">
  <mat-paginator [pageSizeOptions]="[25, 50, 100]"> </mat-paginator>
  <div class="row justify-contend-end w-100 mt-2" *ngIf="results.data.length > 0">
    <div class="col-12 d-flex justify-content-end">
      <button mat-raised-button color="primary" (click)="export()">Esporta risultati</button>
    </div>
  </div>
</div>

<ng-template #detailsModal let-data>
  <mat-dialog-content class="mat-typography">
    <div class="d-flex justify-content-between align-items-baseline">
      <h2 mat-dialog-title>
        Dettaglio -
        <ng-container *ngIf="data.marker.marker_TYPES == 'Strutture socio assistenziali'">Struttura socio assistenziale</ng-container>
        <ng-container *ngIf="data.marker.marker_TYPES != 'Strutture socio assistenziali'">Servizio educativo per l'infanzia</ng-container>
      </h2>
      <button mat-raised-button mat-dialog-close><mat-icon>close</mat-icon></button>
    </div>
    <table class="" aria-describedby="Dettagli del segnaposto">
      <th></th>
      <tr *ngFor="let l of data.lines">
        <ng-container *ngIf="l.title != 'Google Maps'">
          <td class="fs-6 py-1">{{ l.title }}</td>
        </ng-container>
        <td class="spacer"></td>
        <ng-container *ngIf="l.title != 'Google Maps'">
          <td>{{ l.value }}</td>
        </ng-container>
      </tr>
    </table>
    <div *ngFor="let l of data.lines" class="d-flex justify-content-between spacer-top">
      <a class="text-decoration-none" [href]="l.value" target="_blank" *ngIf="l.title == 'Google Maps' && l.value">
        <img class="text-decoration-none" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICB2aWV3Qm94PSIwIDAgNDggNDgiIHdpZHRoPSI0OHB4IiBoZWlnaHQ9IjQ4cHgiPjxwYXRoIGZpbGw9IiM0OGI1NjQiIGQ9Ik0zNS43NiwyNi4zNmgwLjAxYzAsMC0zLjc3LDUuNTMtNi45NCw5LjY0Yy0yLjc0LDMuNTUtMy41NCw2LjU5LTMuNzcsOC4wNglDMjQuOTcsNDQuNiwyNC41Myw0NSwyNCw0NXMtMC45Ny0wLjQtMS4wNi0wLjk0Yy0wLjIzLTEuNDctMS4wMy00LjUxLTMuNzctOC4wNmMtMC40Mi0wLjU1LTAuODUtMS4xMi0xLjI4LTEuN0wyOC4yNCwyMmw4LjMzLTkuODgJQzM3LjQ5LDE0LjA1LDM4LDE2LjIxLDM4LDE4LjVDMzgsMjEuNCwzNy4xNywyNC4wOSwzNS43NiwyNi4zNnoiLz48cGF0aCBmaWxsPSIjZmNjNjBlIiBkPSJNMjguMjQsMjJMMTcuODksMzQuM2MtMi44Mi0zLjc4LTUuNjYtNy45NC01LjY2LTcuOTRoMC4wMWMtMC4zLTAuNDgtMC41Ny0wLjk3LTAuOC0xLjQ4TDE5Ljc2LDE1CWMtMC43OSwwLjk1LTEuMjYsMi4xNy0xLjI2LDMuNWMwLDMuMDQsMi40Niw1LjUsNS41LDUuNUMyNS43MSwyNCwyNy4yNCwyMy4yMiwyOC4yNCwyMnoiLz48cGF0aCBmaWxsPSIjMmM4NWViIiBkPSJNMjguNCw0Ljc0bC04LjU3LDEwLjE4TDEzLjI3LDkuMkMxNS44Myw2LjAyLDE5LjY5LDQsMjQsNEMyNS41NCw0LDI3LjAyLDQuMjYsMjguNCw0Ljc0eiIvPjxwYXRoIGZpbGw9IiNlZDU3NDgiIGQ9Ik0xOS44MywxNC45MkwxOS43NiwxNWwtOC4zMiw5Ljg4QzEwLjUyLDIyLjk1LDEwLDIwLjc5LDEwLDE4LjVjMC0zLjU0LDEuMjMtNi43OSwzLjI3LTkuMwlMMTkuODMsMTQuOTJ6Ii8+PHBhdGggZmlsbD0iIzU2OTVmNiIgZD0iTTI4LjI0LDIyYzAuNzktMC45NSwxLjI2LTIuMTcsMS4yNi0zLjVjMC0zLjA0LTIuNDYtNS41LTUuNS01LjVjLTEuNzEsMC0zLjI0LDAuNzgtNC4yNCwyTDI4LjQsNC43NAljMy41OSwxLjIyLDYuNTMsMy45MSw4LjE3LDcuMzhMMjguMjQsMjJ6Ii8+PC9zdmc+" alt="Icon di Google Maps">
        Visualizza su Google Maps - {{ data.metadata['Indirizzo completo'] }}
      </a>
    </div>
  </mat-dialog-content>
</ng-template>
